import type { Components } from "@mui/material/styles";
import { getContrastColor } from "./utils";

export const MuiSlider: Components["MuiSlider"] = {
  styleOverrides: {
    root: {
      ".MuiSlider-valueLabel": {
        fontWeight: 600,
        color: getContrastColor(),
        background: "var(--color-primary)",
        borderRadius: "5px",
      },
    },
  },
};
